export default __webpack_public_path__ + "static/media/chatIconOK.d56fde17.png";